<template>
  <FreeBottomSheet :name="name">
    <div class="space-y-6 p-4">
      <h2 class="text-text-neutral-primary text-xl font-semibold">Railways</h2>

      <div class="space-y-4">
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <FreeSwitch
              :checked="passengersSelectionEnabled"
              class="text-text-neutral-primary w-full flex-row-reverse"
              @onChange="togglePassengersSelection"
            >
              <template #labelText>Выбор пассажиров на главной</template>
            </FreeSwitch>
          </div>
          <FreeButton
            :disabled="!hasChanges"
            class="green-main-button w-full"
            type="button"
            size="sm"
            @click="applyAndReload"
          >
            Применить
          </FreeButton>
        </div>
      </div>
    </div>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import { FreeBottomSheet, FreeButton, FreeSwitch } from 'freedom-shared';
  import { createStorage } from '@aviata/storage';

  defineProps<{
    name: string;
  }>();

  const RAILWAYS_PASSENGERS_SELECTION_KEY = 'rwfree:passengers_selection';
  const storage = createStorage(localStorage);

  const passengersSelectionEnabled = ref(false);
  const initialValue = ref(false);
  const hasChanges = ref(false);

  const loadPassengersSelectionVariant = () => {
    const passengersSelection = storage.parse(
      RAILWAYS_PASSENGERS_SELECTION_KEY,
    ) as { variant: boolean } | undefined;

    if (!passengersSelection) {
      const variant = Math.random() < 0.5;
      storage.stringify(RAILWAYS_PASSENGERS_SELECTION_KEY, {
        variant,
      });
      passengersSelectionEnabled.value = variant;
      initialValue.value = variant;
    } else {
      passengersSelectionEnabled.value = passengersSelection.variant;
      initialValue.value = passengersSelection.variant;
    }
  };

  const togglePassengersSelection = () => {
    passengersSelectionEnabled.value = !passengersSelectionEnabled.value;
    hasChanges.value = passengersSelectionEnabled.value !== initialValue.value;
  };

  const applyAndReload = () => {
    storage.stringify(RAILWAYS_PASSENGERS_SELECTION_KEY, {
      variant: passengersSelectionEnabled.value,
    });
    window.location.reload();
  };

  onMounted(() => {
    loadPassengersSelectionVariant();
  });
</script>
